/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Admins.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorApiOutContract,
  GetLookups200OneItem,
  GetLookups200ThreeItem,
  GetLookups200TwoItem,
  GetLookupsParams
} from '../pwrdbyQuickMDAdminsApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Returns a collection of lookup items for the specified type. The item shape varies by type:
credit reason types (`standardcreditreasons`, `referralcreditreasons`) return
Pwrdby.QuickMD.Api.Contracts.Lookups.CreditReasonLookupItemOutContract items (extending Pwrdby.QuickMD.Api.Contracts.Lookups.LookupItemOutContract
with `CreditExpiresAtUtc`); `visitcancellationreasons` returns
Pwrdby.QuickMD.Api.Contracts.Lookups.VisitCancellationReasonLookupItemOutContract items (extending the base with
`AppliesToAsyncVisit`); all other types return base Pwrdby.QuickMD.Api.Contracts.Lookups.LookupItemOutContract items.
The 200 response is documented as a `oneOf` union of these shapes.
 */
export const getLookups = (
    params?: GetLookupsParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<GetLookups200OneItem[] | GetLookups200TwoItem[] | GetLookups200ThreeItem[]>(
      {url: `https://admins-api.api.quick.md/api/v1/lookups`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetLookupsInfiniteQueryKey = (params?: GetLookupsParams,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/lookups`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetLookupsQueryKey = (params?: GetLookupsParams,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/lookups`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLookupsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLookups>>>, TError = ErrorApiOutContract | void>(params?: GetLookupsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLookupsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLookups>>> = ({ signal }) => getLookups(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLookupsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLookups>>>
export type GetLookupsInfiniteQueryError = ErrorApiOutContract | void


export function useGetLookupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLookups>>>, TError = ErrorApiOutContract | void>(
 params: undefined |  GetLookupsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLookups>>,
          TError,
          Awaited<ReturnType<typeof getLookups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLookupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLookups>>>, TError = ErrorApiOutContract | void>(
 params?: GetLookupsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLookups>>,
          TError,
          Awaited<ReturnType<typeof getLookups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLookupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLookups>>>, TError = ErrorApiOutContract | void>(
 params?: GetLookupsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns a collection of lookup items for the specified type. The item shape varies by type:
credit reason types (`standardcreditreasons`, `referralcreditreasons`) return
Pwrdby.QuickMD.Api.Contracts.Lookups.CreditReasonLookupItemOutContract items (extending Pwrdby.QuickMD.Api.Contracts.Lookups.LookupItemOutContract
with `CreditExpiresAtUtc`); `visitcancellationreasons` returns
Pwrdby.QuickMD.Api.Contracts.Lookups.VisitCancellationReasonLookupItemOutContract items (extending the base with
`AppliesToAsyncVisit`); all other types return base Pwrdby.QuickMD.Api.Contracts.Lookups.LookupItemOutContract items.
The 200 response is documented as a `oneOf` union of these shapes.
 */

export function useGetLookupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLookups>>>, TError = ErrorApiOutContract | void>(
 params?: GetLookupsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLookupsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Returns a collection of lookup items for the specified type. The item shape varies by type:
credit reason types (`standardcreditreasons`, `referralcreditreasons`) return
Pwrdby.QuickMD.Api.Contracts.Lookups.CreditReasonLookupItemOutContract items (extending Pwrdby.QuickMD.Api.Contracts.Lookups.LookupItemOutContract
with `CreditExpiresAtUtc`); `visitcancellationreasons` returns
Pwrdby.QuickMD.Api.Contracts.Lookups.VisitCancellationReasonLookupItemOutContract items (extending the base with
`AppliesToAsyncVisit`); all other types return base Pwrdby.QuickMD.Api.Contracts.Lookups.LookupItemOutContract items.
The 200 response is documented as a `oneOf` union of these shapes.
 */
export const prefetchGetLookupsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getLookups>>, TError = ErrorApiOutContract | void>(
 queryClient: QueryClient, params?: GetLookupsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetLookupsInfiniteQueryOptions(params,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetLookupsQueryOptions = <TData = Awaited<ReturnType<typeof getLookups>>, TError = ErrorApiOutContract | void>(params?: GetLookupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLookupsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLookups>>> = ({ signal }) => getLookups(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLookupsQueryResult = NonNullable<Awaited<ReturnType<typeof getLookups>>>
export type GetLookupsQueryError = ErrorApiOutContract | void


export function useGetLookups<TData = Awaited<ReturnType<typeof getLookups>>, TError = ErrorApiOutContract | void>(
 params: undefined |  GetLookupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLookups>>,
          TError,
          Awaited<ReturnType<typeof getLookups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLookups<TData = Awaited<ReturnType<typeof getLookups>>, TError = ErrorApiOutContract | void>(
 params?: GetLookupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLookups>>,
          TError,
          Awaited<ReturnType<typeof getLookups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLookups<TData = Awaited<ReturnType<typeof getLookups>>, TError = ErrorApiOutContract | void>(
 params?: GetLookupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns a collection of lookup items for the specified type. The item shape varies by type:
credit reason types (`standardcreditreasons`, `referralcreditreasons`) return
Pwrdby.QuickMD.Api.Contracts.Lookups.CreditReasonLookupItemOutContract items (extending Pwrdby.QuickMD.Api.Contracts.Lookups.LookupItemOutContract
with `CreditExpiresAtUtc`); `visitcancellationreasons` returns
Pwrdby.QuickMD.Api.Contracts.Lookups.VisitCancellationReasonLookupItemOutContract items (extending the base with
`AppliesToAsyncVisit`); all other types return base Pwrdby.QuickMD.Api.Contracts.Lookups.LookupItemOutContract items.
The 200 response is documented as a `oneOf` union of these shapes.
 */

export function useGetLookups<TData = Awaited<ReturnType<typeof getLookups>>, TError = ErrorApiOutContract | void>(
 params?: GetLookupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLookupsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Returns a collection of lookup items for the specified type. The item shape varies by type:
credit reason types (`standardcreditreasons`, `referralcreditreasons`) return
Pwrdby.QuickMD.Api.Contracts.Lookups.CreditReasonLookupItemOutContract items (extending Pwrdby.QuickMD.Api.Contracts.Lookups.LookupItemOutContract
with `CreditExpiresAtUtc`); `visitcancellationreasons` returns
Pwrdby.QuickMD.Api.Contracts.Lookups.VisitCancellationReasonLookupItemOutContract items (extending the base with
`AppliesToAsyncVisit`); all other types return base Pwrdby.QuickMD.Api.Contracts.Lookups.LookupItemOutContract items.
The 200 response is documented as a `oneOf` union of these shapes.
 */
export const prefetchGetLookupsQuery = async <TData = Awaited<ReturnType<typeof getLookups>>, TError = ErrorApiOutContract | void>(
 queryClient: QueryClient, params?: GetLookupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetLookupsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetLookupsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getLookups>>, TError = ErrorApiOutContract | void>(params?: GetLookupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLookupsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLookups>>> = ({ signal }) => getLookups(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLookupsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getLookups>>>
export type GetLookupsSuspenseQueryError = ErrorApiOutContract | void


export function useGetLookupsSuspense<TData = Awaited<ReturnType<typeof getLookups>>, TError = ErrorApiOutContract | void>(
 params: undefined |  GetLookupsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLookupsSuspense<TData = Awaited<ReturnType<typeof getLookups>>, TError = ErrorApiOutContract | void>(
 params?: GetLookupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLookupsSuspense<TData = Awaited<ReturnType<typeof getLookups>>, TError = ErrorApiOutContract | void>(
 params?: GetLookupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns a collection of lookup items for the specified type. The item shape varies by type:
credit reason types (`standardcreditreasons`, `referralcreditreasons`) return
Pwrdby.QuickMD.Api.Contracts.Lookups.CreditReasonLookupItemOutContract items (extending Pwrdby.QuickMD.Api.Contracts.Lookups.LookupItemOutContract
with `CreditExpiresAtUtc`); `visitcancellationreasons` returns
Pwrdby.QuickMD.Api.Contracts.Lookups.VisitCancellationReasonLookupItemOutContract items (extending the base with
`AppliesToAsyncVisit`); all other types return base Pwrdby.QuickMD.Api.Contracts.Lookups.LookupItemOutContract items.
The 200 response is documented as a `oneOf` union of these shapes.
 */

export function useGetLookupsSuspense<TData = Awaited<ReturnType<typeof getLookups>>, TError = ErrorApiOutContract | void>(
 params?: GetLookupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLookupsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLookupsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLookups>>>, TError = ErrorApiOutContract | void>(params?: GetLookupsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLookupsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLookups>>> = ({ signal }) => getLookups(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLookupsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLookups>>>
export type GetLookupsSuspenseInfiniteQueryError = ErrorApiOutContract | void


export function useGetLookupsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLookups>>>, TError = ErrorApiOutContract | void>(
 params: undefined |  GetLookupsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLookupsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLookups>>>, TError = ErrorApiOutContract | void>(
 params?: GetLookupsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLookupsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLookups>>>, TError = ErrorApiOutContract | void>(
 params?: GetLookupsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns a collection of lookup items for the specified type. The item shape varies by type:
credit reason types (`standardcreditreasons`, `referralcreditreasons`) return
Pwrdby.QuickMD.Api.Contracts.Lookups.CreditReasonLookupItemOutContract items (extending Pwrdby.QuickMD.Api.Contracts.Lookups.LookupItemOutContract
with `CreditExpiresAtUtc`); `visitcancellationreasons` returns
Pwrdby.QuickMD.Api.Contracts.Lookups.VisitCancellationReasonLookupItemOutContract items (extending the base with
`AppliesToAsyncVisit`); all other types return base Pwrdby.QuickMD.Api.Contracts.Lookups.LookupItemOutContract items.
The 200 response is documented as a `oneOf` union of these shapes.
 */

export function useGetLookupsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLookups>>>, TError = ErrorApiOutContract | void>(
 params?: GetLookupsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getLookups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLookupsSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




